



















import { Component, Vue, Prop } from 'vue-property-decorator';
import {auth} from '@/agiles/common/auth';

@Component
export default class SignIn extends Vue {
  public isLoading: boolean = true;
  public signupURL:string;
  created() {

    this.signupURL = location.search ? "/signin_local_signup" + location.search : "/signin_local_signup";

      //ログイン処理とマスタ初期化が完了したら画面を描画する
    var path = window.location.pathname;
    if (auth.isResetPwd()){
        auth.login('B2C_1_local_pwdreset2');
    } else if (path == '/signin_office365'){
        auth.login('B2C_1A_office365'); //カスタムポリシーに変更
    } else if (path == '/signin_google'){
        auth.login('B2C_1_google');
    } else if (path == '/signin_local'){
        auth.login('B2C_1_local2');
    } else if (path == '/signin_local_signup'){
        auth.login('B2C_1_local_signup2');
    } else if(auth.ssoStarted==false){ //シングルサインオンがスタートしている場合は画面を表示しない
      this.isLoading = false;
    }
  }    

  onClick(policy:string){
    auth.login(policy);
  }
}
